/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CAM_CLIMATOLOGIA_ITEM = {
  id: 'agro_climatologia',
  screenId: 'agr-cam-climatologia',
  label: 'Climatología',
  description: 'Datos climáticos de largo plazo y diarios por campo o zona.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Consultás el clima asociado a un campo o a una zona. El sistema puede sincronizar datos automáticamente cuando hace falta: temperatura y demás variables desde NASA, y precipitación de largo plazo desde WorldClim.',
      },
      {
        title: 'Paso 1 — Elegir el lugar',
        fields: [
          {
            label: 'Campo',
            description: 'Campo del que querés ver el clima (obligatorio para cargar datos).',
          },
          {
            label: 'Zona',
            description:
              'Opcional. Si elegís zona, el clima se consulta para esa zona; si no, para el campo completo.',
          },
        ],
      },
      {
        title: 'Paso 2 — Pestañas de consulta',
        bullets: [
          'Largo plazo — normales climáticas (incluye precipitación mensual promedio WorldClim).',
          'Diario — serie día a día (temperaturas, radiación, ET₀, etc.). La precipitación diaria no se informa.',
        ],
        paragraphs: [
          'Si aún no hay datos, el sistema puede intentar sincronizarlos. Mientras sincroniza verás un aviso; cuando termina se muestran tablas o gráficos.',
        ],
      },
      {
        title: 'Consejos',
        bullets: [
          'Primero dibujá el límite del campo (o de la zona) en Campos: ayuda a ubicar el punto climático.',
          'Si no ves datos, verificá que el campo tenga ubicación o límite cargado y esperá a que termine la sincronización.',
        ],
      },
    ],
  },
}
